<template>
  <div class="select-wrapper" :class="{'error': error}">
    <select :id="id" :name="name" :value="value" @change="$emit('input', $event.target.value);$emit('change')">
      <option v-for="option in options" :key="option.key" :value="option.key">{{option.description || option.key}}</option>
    </select>
    <i class="material-icons warning">warning</i>
    <slot name="help-text"></slot>
    <slot name="errors"></slot>
  </div>
</template>

<script>
export default {
  name: 'select-input',
  props: {
    value: {
      required: true
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    error: {
      type: Boolean
    },
    options: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/forms/select-input.vue